import { cn } from '@tripleten/cn';

export const cnInput = cn('input');
